// Time-of-day "vibe" shared by every show drawing in the same hour — same royal background, different mood per slot
const VIBES = {
  dawn: { key: "dawn", label: "Golden Morning", ta: "பொன் விடியல்", bg: "linear-gradient(150deg,#b45309 0%,#7c2d12 45%,#1c1917 100%)", accent: "#fde68a", glow: "rgba(253,224,71,.35)", ray: "rgba(255,236,170,.16)", stars: false },
  noon: { key: "noon", label: "Royal Noon", ta: "அரச மதியம்", bg: "linear-gradient(150deg,#1d4ed8 0%,#1e3a8a 50%,#0f172a 100%)", accent: "#fcd34d", glow: "rgba(252,211,77,.3)", ray: "rgba(255,255,255,.12)", stars: false },
  dusk: { key: "dusk", label: "Crimson Evening", ta: "செம்மாலை", bg: "linear-gradient(150deg,#9f1239 0%,#7f1d1d 45%,#1e1b4b 100%)", accent: "#fbbf24", glow: "rgba(251,191,36,.32)", ray: "rgba(255,200,150,.14)", stars: false },
  night: { key: "night", label: "Royal Night", ta: "அரச இரவு", bg: "linear-gradient(150deg,#312e81 0%,#0f172a 55%,#020617 100%)", accent: "#fde68a", glow: "rgba(253,230,138,.3)", ray: "rgba(199,210,254,.12)", stars: true },
};

export function vibeFor(drawTime) {
  const h = parseInt(String(drawTime || "20:00").split(":")[0], 10);
  if (h < 12) return VIBES.dawn;
  if (h < 16) return VIBES.noon;
  if (h < 19) return VIBES.dusk;
  return VIBES.night;
}

export function slotLabel(drawTime, lang) {
  const v = vibeFor(drawTime);
  return lang === "ta" ? v.ta : v.label;
}
